import { formatVRM } from "@/lib/api";

/** UK yellow number plate visual — legal standard, stays yellow. */
export function NumberPlate({ vrm, size = "md", className = "" }) {
  const sizes = {
    sm: "text-base px-2 py-0.5",
    md: "text-xl px-3 py-1",
    lg: "text-3xl px-4 py-1.5",
  };
  return (
    <span
      data-testid="number-plate"
      className={`inline-flex items-center rounded-md font-mono font-bold tracking-wider text-black bg-plate border border-black/20 shadow-sm ${sizes[size]} ${className}`}
      style={{ letterSpacing: "0.08em" }}
    >
      {formatVRM(vrm) || "—"}
    </span>
  );
}
